export interface LiveEndStateType {
    isLiveTimeUp: boolean;
    reservationCartCount: number;
}

export const initialState: LiveEndStateType = {
    isLiveTimeUp: false,
    reservationCartCount: 0,
};
